import { CustomModal } from '../../../../customControl/CustomModal'
import { HotelCancellationReasonProps } from '../bookingUtils'


const HotelCancellationReason = (props: HotelCancellationReasonProps) => {
    const { show, setShow, reason } = props;


    const modlaBodyReason = () => {
        return (
            <div className="mt-2">
                <div className='modal_body_subheader py-2 mt-2'>
                    <div className='text-center me-2 fw-bold text-muted' style={{ fontSize: '18px' }} >
                        Cancellation Reason
                    </div>
                </div>
                <div className='modal_body_subbody mt-2 p-2'>
                    <div className="row">
                        <div className="col-md-4 col-12">
                            <label className='col-form-label text-muted fw-bold' htmlFor="Reason">Reason</label>
                        </div>
                        <div className="col-md-8 col-12">
                            <textarea
                                className='form-control h-100'
                                name="Reason"
                                id="Reason"
                                rows={3}
                                defaultValue={reason}
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <CustomModal
            {...props}
            show={show}
            size='xl'
            onHide={() => setShow(false)}
            modaltitle='Reason'
            modalbody={modlaBodyReason}
            modalfooter=''
        />
    )
}

export default HotelCancellationReason